import type { ShippingQuota } from '../../../modules/api';
import { quotaFullMessage, type ShippingFeesError } from '../../../modules/shipping';

type Props = {
  feesError: ShippingFeesError | null;
  onRetryFees: () => void;
  /** Set when the player's delivery queue has no room left. */
  fullQuota: ShippingQuota | null;
  /** The last submit's failure. */
  error: string | null;
};

const ALERT_CLASS = 'm-0 text-[12px] leading-[16px] text-[var(--co-ShipCard-errorText,#F87171)]';

/** Why "Confirm shipment" can't go through: the quote failed, the queue is
 *  full, or the submit was refused. Same copy as the shared delivery page. */
export function ShipCardFeedback({ feesError, onRetryFees, fullQuota, error }: Props) {
  return (
    <>
      {feesError && (
        <div role="alert" className="flex flex-col items-start gap-1">
          <p className={ALERT_CLASS}>
            {feesError === 'unrateable_address'
              ? "We couldn't calculate shipping for this address. Please check the address and try again."
              : "We couldn't calculate shipping right now. Please try again in a moment."}
          </p>
          {feesError !== 'unrateable_address' && (
            <button type="button" onClick={onRetryFees} className="text-[12px] font-semibold text-[var(--co-ShipCard-linkColor,#C084FC)]">
              Try again
            </button>
          )}
        </div>
      )}
      {fullQuota && (
        <p role="alert" className={ALERT_CLASS}>
          {quotaFullMessage(fullQuota)}
        </p>
      )}
      {error && (
        <p role="alert" className={ALERT_CLASS}>
          {error}
        </p>
      )}
    </>
  );
}
